// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__29TS_","subheader":"ReorderModal_subheader__1dhji","listWrap":"ReorderModal_listWrap__3ZYYC"};